import { Select, Radio, RadioGroup, SelectItem, Spinner, Switch, cn, Modal, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import { enqueueSnackbar } from 'notistack'
import { MdDescription } from 'react-icons/md'
import { IConfigSeller } from '@/models/configSeller'
import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, useButtonClasses } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import StepCard from './StepCard'
import { useStepFooterAction } from '../context/StepFooterActionContext'
import { useTradeinContext } from '../hooks/useTradeinContext'
import NUIAlert from '@/components/Alert/Alert'
import ContractPage from '@/pages/cliente/ContractPage/ContractPage'
import { useJoyRideContext } from '../context/JoyRideContext'
import { validateRUT } from '@/utils/validateRUT.util'
import { isBatteryStepPending, isContractGenerated } from '@/utils/batteryStep'
import { isConsole } from '@/utils/isConsole'

/* showSwitchBattery: true = el equipo se evalúa con el switch de batería, false = no, null = aún no se sabe */
const Contract: React.FC<{ showSwitchBattery?: boolean | null }> = ({ showSwitchBattery = null }) => {
  const { ctx, saveCtx } = useTradeinContext()
  const buttonClasses = useButtonClasses()
  const [loading, setLoading] = useState(false)
  const [edit, setEdit] = useState({ email: '', active: false })
  const userState = useSelector((store: IAppStore) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const { slug } = useParams<{ slug: string }>()
  // const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl'
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isNovabench = (isMacstoreMexico || isFalabellaChile || isRipleyChile) && ctx.tradein.sbu === 'Notebook'
  const isConsola = isConsole(ctx.tradein.sbu)
  const isPhantom = configSeller.config.s3.FOLDER_APP === 'ti_phantom'
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isHuaweiMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx'
  const isTelcelMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx'
  const isTelcelCorpMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx'
  const isHuaweiChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_cl'
  const isHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe'
  // const isParisChile = configSeller.config.s3.FOLDER_APP === 'ti_paris'
  const isSamsungRom = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom'
  const isLiverpoolMexico = configSeller.config.s3.FOLDER_APP === 'ti_liverpool_mx'
  const canEvaluateBatteryWithSwitch = configSeller.config.permisos.SBUS_BRAND_SWITCH_BATTERY === undefined
    ? true
    : configSeller.config.permisos.SBUS_BRAND_SWITCH_BATTERY.some(e => {
      const sbuMatch = e.SBU === ctx.tradein.id_sbu
      const brandMatch = e.BRAND.includes(ctx.tradein.brand)
      console.log('SBU:', e.SBU, '==', ctx.tradein.id_sbu, '->', sbuMatch)
      console.log('BRAND:', e.BRAND, 'includes', ctx.tradein.brand, '->', brandMatch)
      return sbuMatch && brandMatch
    })
  console.log('canEvaluateBatteryWithSwitch:', canEvaluateBatteryWithSwitch)
  const [openModalSign, setOpenModalSign] = useState(false)
  const { setRunTour, setSteps } = useJoyRideContext()
  /* el gate de batería solo tiene sentido antes de generar el contrato: después no hay nada
     que impedir, y bloquearlo taparía la vista del contrato ya firmado en registros viejos
     que nunca recibieron grade quality. */
  const blockForBattery = isBatteryStepPending(ctx.tradein, showSwitchBattery) && !isContractGenerated(ctx.tradein)

  const [hasCampaign, setCampaign] = React.useState(false)

  const handleChangeRUT = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, rut: event.target.value })
  }

  const handleChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, address: event.target.value })
  }

  const handleChangeState = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, state: event.target.value })
  }

  const handleChangeCity = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, city: event.target.value })
  }

  const handleChangeCivilState = (event: React.ChangeEvent<HTMLSelectElement>) => {
    saveCtx({ ...ctx, civil_state: event.target.value })
  }

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, emailRecipient: event.target.value })
  }

  const handleChangeBank = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, bank: event.target.value })
  }

  const handleChangeBankAccount = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, bank_account: event.target.value })
  }

  const handleChangeInterbankAccount = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, interbank_account: event.target.value })
  }

  const handleChangeBankAccountType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    saveCtx({ ...ctx, bank_account_type: event.target.value })
  }

  const handleSave = () => {
    console.log('ctx to save =>', ctx, edit.active, edit.email)
    setLoading(true)
    const dataUpdate = {
      stage: 4,
      id: ctx.tradein.id,
      name: String(ctx.tradein.name),
      lastname: String(ctx.tradein.lastname),
      email: (configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl' || configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx' || configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe') ? String(edit.active ? edit.email.trim() : ctx.tradein.email && ctx.tradein.email.trim() ? ctx.tradein.email.trim() : userState.email.trim()) : ctx.emailRecipient === 'cliente' && configSeller.config.s3.FOLDER_APP !== 'ti_coppel' ? String(edit.active ? edit.email.trim() : ctx.tradein.email.trim()) : configSeller.config.s3.FOLDER_APP === 'ti_coppel' ? String(edit.active ? edit.email.trim() : ctx.tradein.email.trim()) : edit.active ? edit.email.trim() : userState.email.trim(),
      send_type: String(ctx.emailRecipient),
      rut: String(ctx.rut),
      city: ctx.city,
      address: String(ctx.address),
      state: String(ctx.state),
      civil_state: String(ctx.civil_state),
      bank: String(ctx.bank),
      bank_account: String(ctx.bank_account),
      interbank_account: String(ctx.interbank_account),
      bank_account_type: String(ctx.bank_account_type ?? ''),
      store_user: String(userState.id),
      sbu: String(ctx.tradein.sbu),
      brand: ctx.tradein.wasRecalculated === 1 ? String(ctx.tradein.make) : String(ctx.tradein.brand),
      model: ctx.tradein.wasRecalculated === 1 ? String(ctx.tradein.modelName) : String(ctx.tradein.model),
      imei: String(ctx.tradein.serie),
      discount_amount: ctx.tradein.wasRecalculated === 1 ? String(ctx.tradein.new_discount_amount) : ctx.tradein.new_discount_amount ? String(ctx.tradein.new_discount_amount) : String(ctx.tradein.discount_amount),
      seller: slug,
      docusign_id: ctx.tradein.serie.replaceAll('#', '-').replaceAll('/', '-').replaceAll('?', '-').replaceAll('.', '-') + '-' + ctx.tradein.id + '-' + ctx.tradein.id_seller,
      id_seller: ctx.tradein.id_seller,
      phone: ctx.phone,
      campaign: hasCampaign ? '4L' : null,
      isEditMail: edit.active ? 1 : 0
    }
    console.log('dataUpdate ==> ', dataUpdate)
    webApiService.update(dataUpdate)
      .then(() => {
        enqueueSnackbar('Contrato enviado con exito.', { variant: 'success' })
        if (edit.active) { setEdit({ ...edit, active: false }) }
        saveCtx({ ...ctx, reload: true })
        console.log('ctx ==>', ctx)
      })
      .catch((error) => {
        enqueueSnackbar('Hubo un error al intentar guardar el registro.', { variant: 'error' })
        saveCtx({ ...ctx, reload: false })
        console.error('error ==>', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const [isOpen, setIsOpen] = useState(false)
  const onClose = () => setIsOpen(false)

  const canSendHuaweiOnlineContract = (isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && (
    ((ctx.tradein.docusign_id === null || ctx.tradein.docusign_id === '') &&
    (canEvaluateBatteryWithSwitch || ctx.tradein.grade_IA !== null)) ||
    ((ctx.tradein.docusign_id === null || ctx.tradein.docusign_id === '') && canEvaluateBatteryWithSwitch === false)) && ctx.tradein.serie !== null
  console.log('canSendHuaweiOnlineContract', canSendHuaweiOnlineContract)
  const handleEditEmail = () => {
    if (edit.active) {
      handleSave()
    } else {
      setEdit({ email: ctx.tradein.contract_email.trim(), active: true })
    }
  }

  useEffect(() => {
    if (!isOpen) {
      saveCtx({ ...ctx, reload: true })
    } else {
      setSteps([{
        target: '.step-button-sign',
        content: 'Al hacer click en este botón se abrirá la ventana para que el cliente firme el contrato digitalmente. Asegúrate de que el cliente revise toda la información antes de firmar.',
        placement: 'top',
        disableBeacon: true
      }])
      setTimeout(() => {
        setRunTour(true)
      }, 1000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  // console.warn('isParisChile:', isParisChile)
  // console.warn('ctx.tradein.hasFiles === 0:', ctx.tradein.hasFiles === 0)
  // console.warn('ctx.tradein.isBatteryHealthy !== null:', ctx.tradein.isBatteryHealthy !== null)
  // console.warn('!canEvaluateBatteryWithSwitch:', !canEvaluateBatteryWithSwitch)
  // console.log('configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1', configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1)

  useEffect(() => {
    if ((ctx.tradein.rut === null && [4, 11].includes(Number(ctx.tradein.id_status)) && ctx.tradein.recalculate === '0' && ctx.tradein.grade_IA !== null) || (ctx.tradein.rut === null && [4, 11].includes(Number(ctx.tradein.id_status)) && ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === 1 && ctx.tradein.grade_IA !== null)) {
      setSteps([{
        target: '.step-contract',
        content: 'Completa los datos para poder generar el contrato y enviarlo al cliente.',
        placement: 'top',
        disableBeacon: true
      }])
      setTimeout(() => {
        setRunTour(true)
      }, 1000)
    }
    if (configSeller.config.permisos.ENABLE_SIGN_CONTRACT_MODULE === 1 && ctx.tradein.docusign_id !== null && ctx.tradein.id_status === 4) {
      setSteps([{
        target: '.step-sign-contract',
        content: 'Aca el cliente puede firmar el contrato digitalmente. Haz click en el botón para abrir la ventana de firma.',
        placement: 'top',
        disableBeacon: true
      }])
      setRunTour(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.displayContract, ctx.tradein.docusign_id])

  /* replica exacta (sin reinterpretar) de la cadena de condiciones del ternario de abajo, solo para
     saber si la rama que se renderiza es la del formulario de RUT/teléfono/banco/etc. con el botón
     «Guardar» — no HuaweiOnline, y ninguna de las alertas/spinner de las ramas anteriores aplica. */
  const showRutForm = ctx.displayContract !== 0 &&
    !(
      blockForBattery ||
      (
        (!isSamsungMexico && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1) && (
          ((ctx.tradein.isBatteryHealthy === null && ctx.tradein.isExtraControl === null) && !isNovabench && (configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && canEvaluateBatteryWithSwitch)) ||
          (isPhantom && ctx.tradein.isExtraControl === null) ||
          (ctx.tradein.isBatteryHealthy === null && canEvaluateBatteryWithSwitch && ctx.tradein.id_sbu === 1) ||
          (ctx.tradein.isBatteryHealthy === null && !canEvaluateBatteryWithSwitch && ctx.tradein.id_sbu === 1 && !isSamsungMexico) ||
          ((isSamsungRom || isMacstoreMexico) && canEvaluateBatteryWithSwitch === false && ctx.tradein.id_sbu === 3 && ctx.tradein.isBatteryHealthy === null)
        )
      )
    ) &&
    !((ctx.tradein.entry_form_status === 0 && (isMacstoreMexico && ctx.tradein.sbu === 'Notebook') && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1) || ((isSamsungMexico || isHuaweiMexico || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && ctx.tradein.sbu === 'Smartwatch' && ctx.tradein.entry_form_status === 0)) &&
    !(ctx.tradein.isBatteryHealthy === null && isMacstoreMexico && ctx.tradein.sbu !== 'Notebook' && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1) &&
    !loading &&
    (
      (ctx.tradein.rut === null && [4, 11].includes(Number(ctx.tradein.id_status)) && ctx.tradein.recalculate === '0') ||
      (ctx.tradein.rut === null && [4, 11].includes(Number(ctx.tradein.id_status)) && ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === 1)
    ) &&
    !(isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru)

  const guardarContratoDisabled =
    [Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role) ||
    ctx.rut === '' ||
    ctx.phone === '' ||
    (ctx.emailRecipient === '' && configSeller.config.s3.FOLDER_APP !== 'ti_coppel' && !isLiverpoolMexico) ||
    (configSeller.config.permisos.ENABLE_DIR_CONTRACT === 1 && (ctx.address === '' || ctx.city === '')) ||
    (configSeller.config.permisos.ENABLE_DIR_STATE_CONTRACT === 1 && (ctx.state === '')) ||
    (configSeller.config.permisos.ENABLE_CIVIL_STATE_CONTRACT === 1 && (ctx.civil_state === '')) ||
    (configSeller.config.permisos.ENABLE_BANK_INFORMATION === 1 && (ctx.bank === '')) ||
    (configSeller.config.permisos.ENABLE_BANK_INFORMATION === 1 && (ctx.bank_account === '')) ||
    ((configSeller.config.permisos.ENABLE_BANK_INFORMATION === 1 && !isHuaweiMexico && !isHuaweiChile && !isHuaweiOnlineChile && !isHuaweiOnlineMexico && !isHuaweiOnlinePeru) && (ctx.interbank_account === '')) ||
    ((isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && (ctx.bank_account_type === '' || ctx.bank_account_type === undefined || ctx.bank_account_type === null)) ||
    ((isFalabellaChile || isRipleyChile) && ctx.rut !== '' && !validateRUT(ctx.rut))

  /* «Enviar Contrato» (Huawei Online) y «Guardar» (formulario RUT/banco/etc.) viven en ramas
     mutuamente excluyentes: canSendHuaweiOnlineContract exige ser Huawei Online, showRutForm exige
     explícitamente lo contrario. «Firmar Contrato Aqui» y «Editar correo y reenviar» NO se
     fusionaron acá: ambos pueden estar visibles al mismo tiempo en la rama final (contrato ya
     generado), así que se dejaron inline tal cual estaban. */
  const inlineAction = useStepFooterAction(
    canSendHuaweiOnlineContract
      ? (
        <Button size='sm' onClick={handleSave} disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar Contrato'}
        </Button>
        )
      : showRutForm
        ? (
          <Button size='sm' onClick={handleSave} disabled={guardarContratoDisabled}>
            Guardar
          </Button>
          )
        : null,
    [
      canSendHuaweiOnlineContract, showRutForm, loading, guardarContratoDisabled
    ]
  )

  return (
    <StepCard icon={<MdDescription />} title='Contrato' className='step-contract'>
      {
          ctx.displayContract === 0
            ? <NUIAlert type='info'>No disponible por el momento.</NUIAlert>
            : (
                /* en el flujo con switch de batería el contrato espera a que guarden el estado
                   (ese guardado escribe el grade quality). Va fuera del bloque de abajo porque el
                   switch se muestra sin depender de ENABLE_CHECK_BATTERY ni del seller. */
                blockForBattery ||
                (
                  (!isSamsungMexico && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1) && (
                    (
                      ((ctx.tradein.isBatteryHealthy === null && ctx.tradein.isExtraControl === null) && !isNovabench && (configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && canEvaluateBatteryWithSwitch)) ||
                      (isPhantom && ctx.tradein.isExtraControl === null) ||
                      (ctx.tradein.isBatteryHealthy === null && canEvaluateBatteryWithSwitch && ctx.tradein.id_sbu === 1) ||
                      (ctx.tradein.isBatteryHealthy === null && !canEvaluateBatteryWithSwitch && ctx.tradein.id_sbu === 1 && !isSamsungMexico) ||
                      ((isSamsungRom || isMacstoreMexico) && canEvaluateBatteryWithSwitch === false && ctx.tradein.id_sbu === 3 && ctx.tradein.isBatteryHealthy === null)
                    )
                  )
                )
              )
                ? (
                  <NUIAlert type='info'>
                    {blockForBattery
                      ? 'Se requiere actualizar el estado de la batería para firmar el contrato.'
                      : !isConsola
                          ? (configSeller.config.permisos.ENABLE_BATTERY_IMAGE_UPLOAD === 1 && !isTelcelCorpMexico && !isTelcelMexico
                              ? 'Se requiere adjuntar imagen de capacidad de carga del dispositivo (Descuentos) para firmar el contrato.'
                              : 'Se requiere actualizar el estado de la batería para firmar el contrato.')
                          : 'Se requiere adjuntar el número de controles extras entregados (Aumentos) para firmar el contrato.'}
                  </NUIAlert>
                  )
              // : (ctx.tradein.brand === 'Apple' && ctx.tradein.sbu === 'Smartphone' && ctx.tradein.isBatteryHealthy === 1 && ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === null)
              //     ? <NUIAlert type='warning'>Se requiere recalcular el dispositivo.</NUIAlert>

                : ((ctx.tradein.entry_form_status === 0 && (isMacstoreMexico && ctx.tradein.sbu === 'Notebook') && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1) || ((isSamsungMexico || isHuaweiMexico || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && ctx.tradein.sbu === 'Smartwatch' && ctx.tradein.entry_form_status === 0))
                    ? <NUIAlert type='info'>Se debe completar el CheckList para generar el contrato.</NUIAlert>
                    : ctx.tradein.isBatteryHealthy === null && isMacstoreMexico && ctx.tradein.sbu !== 'Notebook' && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1
                      ? <NUIAlert type='info'>Se requiere adjuntar imagen de capacidad de carga del dispositivo (Descuentos) para firmar el contrato.</NUIAlert>
                      : loading
                        ? <Spinner />
                        : (
                            (ctx.tradein.rut === null && [4, 11].includes(Number(ctx.tradein.id_status)) && ctx.tradein.recalculate === '0') ||
                    (ctx.tradein.rut === null && [4, 11].includes(Number(ctx.tradein.id_status)) && ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === 1)
                              ? ((isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru)
                                  ? null
                                  : (
                                    <div className='grid grid-cols-12 gap-4'>
                                      <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                        <label className='text-xs uppercase tracking-widest text-slate-500'>{String(import.meta.env.VITE_LABEL_RUT)}</label>
                                        <Input
                                          value={ctx.rut}
                                          onChange={handleChangeRUT}
                                          className={(isFalabellaChile || isRipleyChile) && ctx.rut !== '' && !validateRUT(ctx.rut) ? 'border-danger' : ''}
                                        />
                                        {(isFalabellaChile || isRipleyChile) && ctx.rut !== '' && !validateRUT(ctx.rut) && (
                                          <span className='text-tiny text-danger'>Ingrese un RUT válido</span>
                                        )}
                                      </div>
                                      <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                        <label className='text-xs uppercase tracking-widest text-slate-500'>Teléfono</label>
                                        <Input
                                          value={ctx.phone}
                                          pattern='[0-9]*'
                                          type='phone'
                                          maxLength={12}
                                          onChange={(e) => saveCtx({ ...ctx, phone: e.target.value })}
                                        />
                                      </div>

                                      {
                                  configSeller.config.permisos.ENABLE_DIR_CONTRACT === 1 && (
                                    <>
                                      <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                        <label className='text-xs uppercase tracking-widest text-slate-500'>Dirección</label>
                                        <Input
                                          value={ctx.address}
                                          onChange={handleChangeAddress}
                                        />
                                      </div>
                                      <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                        <label className='text-xs uppercase tracking-widest text-slate-500'>Ciudad</label>
                                        <Input
                                          value={ctx.city}
                                          onChange={handleChangeCity}
                                        />
                                      </div>
                                      {
                                  configSeller.config.permisos.ENABLE_DIR_STATE_CONTRACT === 1 && (
                                    <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                      <label className='text-xs uppercase tracking-widest text-slate-500'>Estado</label>
                                      <Input
                                        value={ctx.state}
                                        onChange={handleChangeState}
                                      />
                                    </div>
                                  )
                                    }
                                    </>
                                  )
                                }
                                      {
                                          configSeller.config.permisos.ENABLE_BANK_INFORMATION === 1
                                            ? (
                                              <>
                                                <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                                  <label className='text-xs uppercase tracking-widest text-slate-500'>Banco</label>
                                                  <Input
                                                    value={ctx.bank}
                                                    onChange={handleChangeBank}
                                                  />
                                                </div>
                                                <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                                  <label className='text-xs uppercase tracking-widest text-slate-500'>Cuenta Bancaria</label>
                                                  <Input
                                                    value={ctx.bank_account}
                                                    onChange={handleChangeBankAccount}
                                                  />
                                                </div>
                                                {
                                                  !isHuaweiMexico && !isHuaweiChile && !isHuaweiOnlineChile && !isHuaweiOnlineMexico && !isHuaweiOnlinePeru && (
                                                    <div className='col-span-12 md:col-span-4 flex flex-col gap-1.5'>
                                                      <label className='text-xs uppercase tracking-widest text-slate-500'>Cuenta Interbancaria</label>
                                                      <Input
                                                        value={ctx.interbank_account}
                                                        onChange={handleChangeInterbankAccount}
                                                      />
                                                    </div>
                                                  )
                                                }
                                                {
                                                  (isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && (
                                                    <div className='col-span-12 md:col-span-4'>
                                                      <label className='text-xs uppercase tracking-widest text-slate-500'>Tipo de Cuenta Bancaria</label>
                                                      <Select
                                                        selectedKeys={ctx.bank_account_type ? [ctx.bank_account_type] : []}
                                                        onChange={handleChangeBankAccountType}
                                                        placeholder='Seleccione el tipo de cuenta'
                                                        size='sm'
                                                        variant='bordered'
                                                      >
                                                        <SelectItem key='Cuenta Corriente' textValue='Cuenta Corriente'>Cuenta Corriente</SelectItem>
                                                        <SelectItem key='Cuenta Vista' textValue='Cuenta Vista'>Cuenta Vista</SelectItem>
                                                        <SelectItem key='Cuenta de Ahorro' textValue='Cuenta de Ahorro'>Cuenta de Ahorro</SelectItem>
                                                      </Select>
                                                    </div>
                                                  )
                                                }
                                              </>
                                              )
                                            : null
                                          }
                                      {
                                  configSeller.config.permisos.ENABLE_CIVIL_STATE_CONTRACT === 1 && (
                                    <div className='col-span-12 md:col-span-4'>
                                      <label className='text-xs uppercase tracking-widest text-slate-500'>Estado civil</label>
                                      <Select
                                        value={ctx.civil_state}
                                        onChange={handleChangeCivilState}
                                        placeholder='Seleccione'
                                        size='sm'
                                        variant='bordered'
                                      >
                                        <SelectItem key='soltero' value='soltero'>Soltero</SelectItem>
                                        <SelectItem key='casado' value='casado'>Casado</SelectItem>
                                        <SelectItem key='viudo' value='viudo'>Viudo</SelectItem>
                                        <SelectItem key='divorciado' value='divorciado'>Divorciado</SelectItem>
                                      </Select>
                                    </div>
                                  )
                                }
                                      <div className='col-span-12'>
                                        {
                                    (configSeller.config.s3.FOLDER_APP !== 'ti_coppel' && !isLiverpoolMexico)
                                      ? (
                                        <RadioGroup orientation='horizontal' label='Enviar contrato al correo' onChange={(value) => handleChangeEmail(value)} className='mt-4'>
                                          <Radio value='cliente'>Cliente</Radio>
                                          <Radio value='modulo'>Módulo</Radio>
                                        </RadioGroup>
                                        )
                                      : null
                                  }
                                      </div>
                                      <div className='col-span-12 md:col-span-4'>
                                        {
                                    configSeller.config.s3.FOLDER_APP === 'ti_macstore'
                                      ? (
                                        <Switch
                                          color='success'
                                          isSelected={hasCampaign}
                                          onValueChange={setCampaign}
                                          isDisabled
                                          style={{ display: 'none' }}
                                          classNames={{
                                            base: cn(
                                              'inline-flex flex-row-reverse w-full max-w-md bg-content1 hover:bg-content2 items-center',
                                              'justify-between cursor-pointer rounded-lg gap-2 p-4 border-2 border-transparent',
                                              'data-[selected=true]:border-success'
                                            ),
                                            wrapper: 'p-0 h-4 overflow-visible',
                                            thumb: cn(
                                              'w-6 h-6 border-2 shadow-lg',
                                              'group-data-[hover=true]:border-success',
                                              'group-data-[selected=true]:ms-6',
                                              'group-data-[pressed=true]:w-7',
                                              'group-data-[selected]:group-data-[pressed]:ms-4'
                                            )
                                          }}
                                        >
                                          <div className='flex flex-col gap-1'>
                                            <p className='text-medium'>¿Es programa 4Life?</p>
                                            <p className='text-tiny text-default-700'>
                                              Estado: <strong style={{ color: hasCampaign ? 'green' : '#3f3f46' }}>{hasCampaign ? 'Activado' : 'Desactivado'}</strong>
                                            </p>
                                          </div>
                                        </Switch>
                                        )
                                      : null
                                  }
                                      </div>
                                    </div>
                                    ))
                              : (
                            //  isSamsungPeru && ctx.tradein.url_contract === null && ctx.tradein.rut === null
                            //   ? <NUIAlert type='info'>Se requiere adjuntar imagenes del dispositivo.</NUIAlert>
                            //   : ctx.tradein.rut !== null && [3, 4, 5, 7, 8, 9, 11].includes(Number(ctx.tradein.id_status)) && (
                                <div className='col-span-12 md:col-span-4'>
                                  <div className='mb-4 flex items-center justify-between'>
                                    <p className='my-4'>N° identificador de Contrato: <strong>{ctx.tradein.docusign_id}</strong></p>
                                    {
                                      (configSeller.config.permisos.ENABLE_SIGN_CONTRACT_MODULE === 1 && ctx.tradein.docusign_id !== null && ctx.tradein.id_status === 4) && (
                                        // <Link href={`${window.location.origin}/${slug}/contract/${ctx.tradein.docusign_id}`} target='_blank' rel='noreferrer' className='ml-2'>
                                        <Button className='step-sign-contract' size='sm' onClick={() => setIsOpen(true)}>Firmar Contrato Aqui</Button>
                                        // </Link>
                                      )
                                    }

                                  </div>

                                  <NUIAlert type='success'>
                                    <div className='flex flex-col justify-around gap-2'>
                                      <div>
                                        Contrato creado y enviado a: <strong>{ctx.tradein.contract_email}</strong>

                                      </div>
                                      <div className='flex flex-col justify-start gap-2 text-start'>
                                        {
                                          edit.active
                                            ? (
                                              <div>
                                                <Input
                                                  value={edit.email}
                                                  onChange={(value) => setEdit({ ...edit, email: value.target.value })}
                                                />
                                              </div>

                                              )
                                            : null
                                        }
                                        <div><Button size='sm' className='w-full' variant='secondary' onClick={handleEditEmail}>{edit.active ? 'Reenviar contrato' : 'Editar correo y reenviar'}</Button></div>
                                      </div>
                                    </div>
                                  </NUIAlert>

                                  <div className='mb-4 flex items-center justify-between mt-4'>
                                    {
                                ctx.tradein.url_contract && (
                                  <a href={ctx.tradein.url_contract} target='_blank' rel='noreferrer' className={cn(buttonClasses({ size: 'sm' }))}>Descargar</a>
                                )
                              }
                                    {
                                (ctx.tradein.url_contract && configSeller.config.s3.FOLDER_APP === 'ti_macstore' && ctx.tradein.id_status === 5) && (
                                  <a href={ctx.tradein.url_contract_multiple ?? ctx.tradein.url_contract.replace(/\.pdf$/, '_final.pdf')} target='_blank' rel='noreferrer' className={cn(buttonClasses({ size: 'sm' }), 'ml-2')}>Descargar con codigos de barra</a>
                                )
                              }
                                  </div>
                                </div>
                                )
                          )
        }
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        placement='center'
        backdrop='blur'
        scrollBehavior='inside'
        isDismissable={false}
        size='5xl'
      >
        <ModalContent>
          {(onClose) => (
            <>
              {/* <ModalHeader className='flex flex-col gap-1'>Firmar contrato</ModalHeader> */}
              <ModalBody>
                <ContractPage loginCodeProps={ctx.tradein.docusign_id} openModalSignProps={openModalSign} setOpenModalSign={setOpenModalSign} slug={slug} setIsOpen={setIsOpen} />
              </ModalBody>
              <ModalFooter>
                <Button size='sm' variant='destructive' onClick={onClose}>
                  Cancelar
                </Button>
                <Button
                  onClick={() => setOpenModalSign(true)}
                  className='step-button-sign'
                  size='sm'
                >
                  Firmar
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
      {/* Sin footer compartido (página de detalle clásica) el botón del paso se dibuja acá. */}
      {inlineAction && <div className='flex justify-end pt-4'>{inlineAction}</div>}
    </StepCard>
  )
}

export default Contract
